import { Autocomplete, Icon, InputBase, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { Task } from "../../entities/task";
import { useKronosTasks } from "../../../redux/kronos/kronosHooks";

/**
 * @param {taskAutocompleteProps} taskAutocompleteProps PriorityLevel object from API
 * @returns {ReactElement} Task Autocomplete
 */
export function TaskAutocomplete({
  taskID,
  onChange,
  variant,
  size,
  helperText,
  disabled,
  autoFocus,
}: taskAutocompleteProps) {
  const [inputValue, setInputValue] = useState("");
  const { tasks } = useKronosTasks();
  const task = tasks.find((t) => t.id === taskID);

  useEffect(() => {
    if (task) {
      setInputValue(`${task.name}`);
    }
  }, [task]);

  return (
    <Autocomplete
      value={task ?? null}
      onChange={(_e, newValue) => {
        onChange(newValue);
      }}
      disabled={disabled}
      inputValue={inputValue}
      onInputChange={(_e, newInputValue) => {
        setInputValue(newInputValue);
      }}
      size={size}
      getOptionLabel={(option) => `${option.name}`}
      options={tasks}
      clearIcon={<Icon sx={{ fontSize: 15 }} className="fa-solid fa-xmark" />}
      renderInput={(params) =>
        variant === "inputBase" ? (
          <div ref={params.InputProps.ref}>
            <InputBase
              inputProps={{ ...params.inputProps }}
              fullWidth
              sx={{ fontSize: 14 }}
              placeholder="Select a task..."
              autoFocus={autoFocus}
            />
          </div>
        ) : (
          <TextField
            variant={variant}
            {...params}
            fullWidth
            sx={{ fontSize: 14 }}
            placeholder="Select a task..."
            autoFocus={autoFocus}
            label="Task"
            helperText={helperText}
          />
        )
      }
    />
  );
}

type taskAutocompleteProps = {
  taskID?: number;
  onChange: (task: Task | null) => void;
  variant?: "standard" | "filled" | "outlined" | "inputBase" | undefined;
  size?: "small" | "medium" | undefined;
  helperText?: string;
  disabled?: boolean;
  autoFocus?: boolean;
};
